import React from 'react';
import './Home.css';
import VideoCarousel from '../components/Shared/VideoCarousel';
import Modes from '../components/Shared/Modes';
import DetectorText from '../components/Shared/DetectorText';
import Mouse from '../components/Shared/Mouse';
import WhyFacelead from '../components/Home/WhyFacelead';
import { Helmet } from 'react-helmet';

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>FaceLead - Control your computer with face gestures</title>
        <meta name="description" content="No need for a mouse, a keyboard, or any additional hardware. Use only face gestures to take full control of your computer." />
      </Helmet>
      <VideoCarousel />
      <DetectorText />
      <Modes />
      <Mouse />
      <WhyFacelead />
    </div>
  );
};


export default Home;
